
import { Base } from '../base-component';

import './contact-us-item.component.scss';

export class ContactUsItem extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/contact-us-item/contact-us-item.component.ts